// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2lhzK","title":"FrontImage_title__27Diq"};